// 레이드 이름 + 입장 가능 레벨 (예시는 0 → 실제 수치로 채워 넣어)
export const RAIDS = [
  { name: '폭풍의 지휘관, 베히모스 [노말] 2관문', minLevel: 1640 },
  { name: '폭풍의 지휘관, 베히모스 [노말] 1관문', minLevel: 1640 },
  { name: '서막 : 붉어진 백야의 나선 [하드] 2관문', minLevel: 1640 },
  { name: '서막 : 붉어진 백야의 나선 [하드] 1관문', minLevel: 1640 },
  { name: '1막 : 대지를 부수는 업화의 궤적 [노말] 2관문', minLevel: 1660 },
  { name: '1막 : 대지를 부수는 업화의 궤적 [노말] 1관문', minLevel: 1660 },
  { name: '1막 : 대지를 부수는 업화의 궤적 [하드] 2관문', minLevel: 1680 },
  { name: '1막 : 대지를 부수는 업화의 궤적 [하드] 1관문', minLevel: 1680 },
  { name: '2막 : 부유하는 악몽의 진혼곡 [노말] 2관문', minLevel: 1670 },
  { name: '2막 : 부유하는 악몽의 진혼곡 [노말] 1관문', minLevel: 1670 },
  { name: '2막 : 부유하는 악몽의 진혼곡 [하드] 2관문', minLevel: 1690 },
  { name: '2막 : 부유하는 악몽의 진혼곡 [하드] 1관문', minLevel: 1690 },
  { name: '3막 : 칠흑, 폭풍의 밤 [노말] 3관문', minLevel: 1680 },
  { name: '3막 : 칠흑, 폭풍의 밤 [노말] 2관문', minLevel: 1680 },
  { name: '3막 : 칠흑, 폭풍의 밤 [노말] 1관문', minLevel: 1680 },
  { name: '3막 : 칠흑, 폭풍의 밤 [하드] 3관문', minLevel: 1700 },
  { name: '3막 : 칠흑, 폭풍의 밤 [하드] 2관문', minLevel: 1700 },
  { name: '3막 : 칠흑, 폭풍의 밤 [하드] 1관문', minLevel: 1700 },
  { name: '4막 : 파멸의 성채 [노말] 2관문', minLevel: 1700 },
  { name: '4막 : 파멸의 성채 [노말] 1관문', minLevel: 1700 },
  { name: '4막 : 파멸의 성채 [하드] 2관문', minLevel: 1720 },
  { name: '4막 : 파멸의 성채 [하드] 1관문', minLevel: 1720 },
  { name: '종막 : 최후의 날 [노말] 2관문', minLevel: 1710 },
  { name: '종막 : 최후의 날 [노말] 1관문', minLevel: 1710 },
  { name: '종막 : 최후의 날 [하드] 2관문', minLevel: 1730 },
  { name: '종막 : 최후의 날 [하드] 1관문', minLevel: 1730 },
  { name: '어둠군단장 카멘 [EX 노먈] 1관문', minLevel: 1690 },
  { name: '어둠군단장 카멘 [EX 하드] 1관문', minLevel: 1720 },

  { name: '드렉탈라스', minLevel: 1700 },
  { name: '스콜라키아', minLevel: 1680 },
  { name: '아게오로스', minLevel: 1640 },
];

// OCR 매칭용: 이름 배열 그대로 유지
export const RAID_NAMES = RAIDS.map(r => r.name);

// 빠른 조회용 맵 + 헬퍼
const RAID_LEVEL_BY_NAME = new Map(RAIDS.map(r => [r.name, r.minLevel]));
export function getRaidMinLevel(name) {
  return RAID_LEVEL_BY_NAME.get(name) ?? 0;
}
